export default __webpack_public_path__ + "static/media/wdoge.3ad36f65.png";